import React from "react";
import styled from "styled-components";
import { DetailedCourse } from "@domain/lms/course/course";
import { VideoSection } from "@domain/lms/course/courseSection";
import { getAssetById } from "@domain/lms/course/utils";
import { TooshareVideoPlayer } from "@ui/components/media/tooshareVideoPlayer";
import { VideoPlayer } from "@ui/components/media/videoPlayer";

interface VideoSectionViewProps extends React.HTMLAttributes<HTMLDivElement> {
	section: VideoSection;
	course: DetailedCourse;
}
export const VideoSectionView: React.FC<VideoSectionViewProps> = ({ section, course, ...htmlProps }) => {
	const asset = "assetId" in section && getAssetById(course.content, section.assetId);

	return (
		<Container {...htmlProps}>
			{"url" in section && section.url != null ? (
				<VideoPlayer source={section.url} />
			) : asset ? (
				<TooshareVideoPlayer asset={asset} />
			) : null}
		</Container>
	);
};

const Container = styled.div`
	width: 100%;
	border-radius: 12px;
	overflow: hidden;
`;
